const Routes = {
    home: 'home',
    contactForm: 'contactForm',
    callRequestForm: 'callRequestForm',
    profileSelect: 'profileSelect',
    profileDetail: 'profileDetail',
    loading: 'loading',
    smsPrivacyPolicy: 'smsPrivacyPolicy',
}

export default Routes;
